import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import { ArrowRight, Loader } from 'lucide-react';
import ContentRenderer from './admin/ContentRenderer';
import ContactButton from '../components/ContactButton';
const ArticlePage = () => {
  const { topicId, articleId } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    // גלילה לחלק העליון של הדף
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // לגלילה חלקה
    });
  }, []); // ריק dependency array - רץ רק בטעינה הראשונית
  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const articleDoc = await getDoc(doc(db, 'articles', articleId));
        if (articleDoc.exists()) {
          setArticle({ id: articleDoc.id, ...articleDoc.data() });
        } else {
          setError('המאמר לא נמצא');
        }
      } catch (err) {
        console.error('Error fetching article:', err);
        setError('אירעה שגיאה בטעינת המאמר');
      } finally {
        setLoading(false);
      }
    };

    fetchArticle();
  }, [articleId]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader className="w-8 h-8 animate-spin text-blue-500" />
      </div>
    );
  }

  if (error || !article) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center p-8 bg-red-50 rounded-lg">
          <h2 className="text-2xl font-bold text-red-800">{error}</h2>
          <Link 
            to={`/topic/${topicId}`}
            className="mt-4 inline-flex items-center text-[#9bc4e4] hover:text-blue-800"
          >
            <ArrowRight className="w-4 h-4 ml-2" />
            <span>חזור לדף הנושא</span>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-3xl mx-auto px-4">
        {/* Navigation */}
        <Link 
          to={`/topic/${topicId}`}
          className="inline-flex items-center text-[#9bc4e4] hover:text-blue-800 mb-8"
        >
          <ArrowRight className="w-4 h-4 ml-2" />
          <span>חזור לדף הנושא</span>
        </Link>

        {/* Article Content */}
        <article className="bg-white rounded-xl shadow-md p-8">
          <header className="mb-8">
            <div className="text-3xl font-bold text-gray-900 mb-4">
              <ContentRenderer content={article.title} />
            </div>
            {/* <time className="text-sm text-gray-500" dateTime={article.createdAt}>
              {new Date(article.createdAt).toLocaleDateString('he-IL', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </time> */}
          </header>

          <div className="prose prose-lg max-w-none">
            <ContentRenderer content={article.content} />
          </div>
        </article>
        <ContactButton className="mt-4 mb-2" />
      </div>
    </div>
  );
};

export default ArticlePage;